__turbopack_context__.v({
  "gridCanvas": "FlickeringGrid-module__ZaykNG__gridCanvas",
  "gridRoot": "FlickeringGrid-module__ZaykNG__gridRoot",
});
